<template>
  <div>
    <span class="text-bold" v-if="direction === 'INBOUND'">Appel entrant</span>
    <span v-else>Appel sortant</span>

    <br />

    <span class="text-success" v-if="result === 'ANSWERED'">Répondu</span>
    <span class="text-primary" v-if="result === 'VOICEMAIL'">Répondeur</span>
    <span class="text-warning" v-if="result === 'TRANSFERRED'">Transfert</span>
  </div>
</template>

<script>
export default {
  props: {
    result: {
      required: true,
      type: String,
    },

    direction: {
      required: true,
      type: String,
    },
  },
};
</script>

<style scoped>
.text-bold {
  font-weight: 700;
}
</style>
